import gql from 'graphql-tag';

export const CREATE_WIDGET_SETTINGS = gql`
  mutation widgetSetSettings(
    $photo: Upload
    $widgetSettings: WidgetCustomizationInput
  ) {
    widgetSetSettings(photo: $photo, widgetSettings: $widgetSettings) {
      id
    }
  }
`;

export const UPDATE_WIDGET_SETTINGS = gql`
  mutation widgetUpdateSettings(
    $photo: Upload
    $widgetSettings: WidgetCustomizationInput
  ) {
    widgetUpdateSettings(photo: $photo, widgetSettings: $widgetSettings) {
      widget {
        id
      }
    }
  }
`;
